import api, { Query } from '../api'
import { CurrentUser } from '../currentUser'

export function loadUsers(query?: Query | undefined): Promise<Array<CurrentUser>> {
    return api({ path: '/users/', query })
}
